import { createContext } from "react";

export const TestContext = createContext()
export const IndividualWorkPlanContext = createContext()
export const ReviewsContext = createContext()
